import backend from '@/API/services/data'

export default {
  state: {
    clients: [],
    backendData: null,
    searchRes: [],
  },
  mutations: {
    SET_CLIENTS: (state, payload) => {
      state.clients = payload
    },
    SET_BACKENDDATA_DATA: (state, payload) => {
      state.backendData = payload.data
    },
    SET_SEARCH_DATA: (state, payload) => {
      state.searchRes = payload.data
    },
  },
  actions: {
    getClients: async ({ commit }, payload) => {
      try {
        const { data } = await backend.getClients(payload)
        commit('SET_CLIENTS', data)
      } catch(err) {
        console.log(err)
      }

    },
    fetchData: async ({ commit }, payload) => {
      try {
        const { data } = await backend.getBackendData(payload)
        commit('SET_BACKENDDATA_DATA', data)
      } catch(err) {
        console.log(err)
      }
    },
  },
}
